import React from 'react';
import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Icon, IconSize, IconType } from 'ui-toolkit';

export interface ProgressMarkerProps {
  icon?: IconType | null;
  isCurrent?: boolean | null;
  isHidden?: boolean | null;
  isPast?: boolean | null;
}

export const StyledProgressMarker = styled.div<{
  hasIcon?: boolean | null;
  isCurrent?: boolean | null;
  isHidden?: boolean | null;
  isPast?: boolean | null;
}>`
  height: 24px;
  width: 24px;
  transform: ${({ hasIcon, isCurrent, isHidden }) =>
    isHidden ? 'scale(0, 0)' : isCurrent || hasIcon ? 'scale(1.33333, 1.33333)' : 'none'};
  transition: transform 250ms 500ms;
  ${({ hasIcon, isHidden, isPast, theme }) =>
    !isHidden
      ? `
    background-color: ${hasIcon ? theme.colors.yellow : isPast ? theme.colors.tertiaryVariant : theme.colors.white};
    box-shadow: 0 0 2px 2px ${theme.colors.shadow};
    border: 1px solid ${hasIcon ? theme.colors.yellowVariant : isPast ? theme.colors.tertiary : theme.colors.white};
    border-radius: 12px;
    position: relative;
  `
      : null}
`;

export const StyledProgressMarkerIcon = styled(Icon)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: ${(props) => (props.type === IconType.Party ? 'translate(-20%, -80%)' : 'translate(-50%, -50%)')};
`;

const ProgressMarker: React.FC<ProgressMarkerProps> = ({ icon, isCurrent, isHidden, isPast }) => {
  const themeContext = useContext(ThemeContext);
  return (
    <StyledProgressMarker hasIcon={!!icon} isCurrent={isCurrent} isHidden={isHidden} isPast={isPast}>
      {icon ? <StyledProgressMarkerIcon type={icon} size={IconSize.Regular} color={themeContext.colors.black} /> : null}
    </StyledProgressMarker>
  );
};

export default ProgressMarker;
